import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const trackingCardTokenizationFailed: CheckoutActionCreator = (err) => (dispatch) => {
  dispatch({
    type: actionTypes.CHECKOUT_CARD_TOKENIZATION_FAILED,
    trackingData: {
      actionType: 'CardTokenization Failed',
      error_reason: err,
    },
  })
}
